import { SelectField, SelectFieldOption } from "components/Form/FormikControls";
import React from "react";
import { EMPTY_ARRAY } from "lib";
import { getIn } from "formik";
import { FieldValueTypeRuleValueFormatMap } from "containers/Settings/RuleBooks/constants";
import { RuleValueFormatOptionsByRawValueFormat } from "lib/billingUserInterface";

export function getOutputFormatOptions(
  value: any,
  formField: string,
  ruleField: string,
) {
  // Get the output format options for a quantity / unit price field.
  // The output format is stored differently depending on if we are editing the form or not

  // Note this value needs to be mapped using FieldValueTypeRuleValueFormatMap
  const fieldRawFormat = getIn(value, formField);
  // Otherwise fall back to what's on the rule.  This value is already mapped.
  const ruleRawFormat = getIn(value, ruleField);
  const rawValueFormat =
    FieldValueTypeRuleValueFormatMap[fieldRawFormat] || ruleRawFormat;

  return RuleValueFormatOptionsByRawValueFormat[rawValueFormat] || EMPTY_ARRAY;
}

interface RuleOutputFormatFieldProps {
  name: string;
  label: string;
  altTooltip?: string;
  options?: SelectFieldOption[];
}

export function RuleOutputFormatField(
  props: RuleOutputFormatFieldProps,
): React.JSX.Element {
  const { name, label, altTooltip, options = EMPTY_ARRAY } = props;

  return (
    <SelectField
      label={label}
      name={name}
      required
      options={options}
      menuPortalTarget={document.body}
      altTooltip={altTooltip}
    />
  );
}
